import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserStatusCssPipe } from '../../pipes/user-status-css.pipe';
import { UserStatusLabelPipe } from '../../pipes/user-status-label.pipe';
import { UserStatus } from '../../enums/user-status';

@Component({
  selector: 'app-user-status',
  imports: [CommonModule, UserStatusCssPipe, UserStatusLabelPipe],
  templateUrl: './user-status.component.html',
  styleUrl: './user-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserStatusComponent {
  public readonly status = input.required<UserStatus>();
}
